import { render, staticRenderFns } from "./ApplicantFormStep8.vue?vue&type=template&id=1040b506&scoped=true"
import script from "./ApplicantFormStep8.vue?vue&type=script&lang=js"
export * from "./ApplicantFormStep8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040b506",
  null
  
)

export default component.exports